export const BADGE_THEMES = {
    LIGHT: 'LIGHT',
    DARK: 'DARK',
    CUSTOM: 'CUSTOM'
};
